import { DOCUMENT_REQUEST_CATEGORY, QUESTIONNAIRE_REQUEST_CATEGORY } from 'common/constants/process-management';
import { sortQuestionsById } from 'pages/ProcessManagement/utils/sortQuestions';
import CurrentRequestedDocumentTables from './CurrentRequestedDocumentTables';
import { CurrentRequestedDocumentProps, DocumentProgress, QuestionProgress } from './types';

const CurrentRequestedDocument = ({ currentInformationRequests }: CurrentRequestedDocumentProps) => {
  const documents = currentInformationRequests.find(request => request.category === DOCUMENT_REQUEST_CATEGORY);
  const questionnaireRequest = currentInformationRequests.find(request => request.category === QUESTIONNAIRE_REQUEST_CATEGORY);

  const filteredDocuments = {
    id: documents?.id,
    responsible_users:
      documents?.responsible_users?.map(user => ({
        full_name: user.full_name,
      })) || [],
    delegated_responsible_party: documents?.delegated_responsible_party,
    delegation_thread: documents?.delegation_thread,
    delegation_depth: documents?.delegation_depth,
    progress:
      (documents?.progress?.filter(
        (item): item is DocumentProgress => 'files' in item && 'is_uploaded' in item && 'tags' in item
      ) as any) || [],
  };

  // Extract questions from the questionnaire information request (not template questions)
  const questions: QuestionProgress[] = sortQuestionsById(
    questionnaireRequest?.progress?.filter(
      (item): item is QuestionProgress =>
        'children_questions' in item
        && 'question_type' in item
        && 'options' in item
        && 'answers' in item
        && 'parent_question' in item
    ) || []
  );

  return <CurrentRequestedDocumentTables documents={filteredDocuments} questions={questions} />;
};

export default CurrentRequestedDocument;
